export default "__VITE_ASSET__mW_wIeL9__"